module.exports = __webpack_public_path__ + "img/multiplier_free_2.a2522c06.png";